module.exports = __webpack_public_path__ + "img/message_word.7ff8fd68.png";